import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function Proof() {
  return <section className="py-24 px-6 bg-cream-100 text-center" data-id="element-144">
      <div className="max-w-3xl mx-auto" data-id="element-145">
        <FadeIn className="mb-20" data-id="element-146">
          <Button href="https://thealphamethods.com/cart/44267718836310:1" target="_blank" rel="noopener noreferrer" data-id="element-147">
            SÍ, QUIERO RESTAURAR MI HOGAR POR SOLO $6.36
          </Button>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-148">
          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-cream-200 relative" data-id="element-149">
            <div className="text-6xl text-gold-300 absolute top-4 left-6 font-serif leading-none" data-id="element-150">
              "
            </div>
            <p className="text-xl md:text-2xl text-brown-800 leading-relaxed italic relative z-10 pt-4" data-id="element-151">
              Cientos de hogares han pasado del caos a la calma después de
              aplicar este principio de orden. Cuando el orden de Dios llega a
              una casa, la confusión tiene que salir. Familias reportan que,
              tras la unción, los niños duermen mejor y la comunicación vuelve a
              fluir con ternura.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}